jQuery(document).ready(function ($) {
    const hotels = $('.hotels__hotels');

    hotels.each(function () {
        const $gallery = $(this);

        const hotels_carousel = new Swiper(`#${$gallery.attr('id')}`, {
            loop: false,

            slidesPerView: 1,
            slidesPerGroup: 1,

            longSwipes: false,

            spaceBetween: 16,

            grabCursor: true,

            autoplay: true,
            delay: 8000,

            navigation: {
                prevEl: '.hotels__hotels--prev',
                nextEl: '.hotels__hotels--next'
            },

            breakpoints: {
                768: {
                    slidesPerView: 2.5,

                    spaceBetween: 32
                }
            }
        });
    });

    // Each hotel's Book Now opens that hotel's own Mews booking engine (the page-level one belongs to this site)
    const distributors = {};

    $(document).on('click', '.hotel-distributor', function (event) {
        // Falls back to following the hotel link if the Mews script hasn't loaded
        if (typeof Mews === 'undefined') return;

        event.preventDefault();

        const code = $(this).data('distributor-code');

        if (distributors[code]) {
            distributors[code].open();
            return;
        }

        Mews.Distributor({ configurationIds: [code] }, function (distributor) {
            distributors[code] = distributor;
            distributor.open();
        });
    });
});
